export const SUBMISSION_STATE = { submitted: 'warning', approved: 'success', rejected: 'error' }

export const FRIENDSHIP_STATUS = { pending: 'warning', accepted: 'success', declined: 'neutral' }

export const MEDIA_TYPE = { photo: 'info', video: 'secondary' }

export const FLAGGED = 'error'
export const HIDDEN = 'neutral'
export const REVIEWED = 'success'
export const UNREVIEWED = 'warning'
